module.exports = __webpack_public_path__ + "img/KRW.8d16d62e.png";